import React, { useRef } from "react";

import isEqual from "lodash/isEqual";
import { FormSpy } from "react-final-form";
import { useDispatch } from "react-redux";
import { change } from "redux-form";

export const useFinalFormToRedux = (reduxFormName, formSection) => {
  const dispatch = useDispatch();
  const lastState = useRef({});

  const handleFormChange = (formState) => {
    const currentValues = formSection ? formState.values[formSection] : formState.values;
    const previousValues = formSection ? lastState.current[formSection] : lastState.current;

    // Compare currentValues and previousValues
    if (!isEqual(currentValues, previousValues)) {
      Object.entries(currentValues).forEach(([fieldName, fieldValue]) => {
        // Dispatch only if the field value has changed
        if (!isEqual(previousValues?.[fieldName], fieldValue)) {
          const fieldPath = formSection ? `${formSection}.${fieldName}` : fieldName;
          dispatch(change(reduxFormName, fieldPath, fieldValue));
        }
      });
    }

    // Update lastState ref with the current values for the next comparison
    lastState.current = formState.values;
  };

  // Render FormSpy to listen for changes
  const FormStateToReduxComponent = () => (
    <FormSpy
      onChange={handleFormChange}
      subscription={{
        values: true,
      }}
    />
  );

  return FormStateToReduxComponent;
};
export default useFinalFormToRedux;
